<template>
  <div id="productBox">
    <Nav></Nav>
    <Header></Header>
    <div class="productCate">
      <div class="w">
        <div class="search_box">
          <input type="text" placeholder="请输入您要搜索的信息" v-model="keywords" />
          <button class="search-button" @click="searchProductList"></button>
        </div>
        <div class="cateCard">
          <dl class="cateItem clearfix">
            <dt>产品分类：</dt>
            <template v-for="(item,index) in menuList">
              <dd :key="item.id">
                <a
                  :class="!index ? 'current' :''"
                  href="javascript:void(0);"
                  :key="item.id"
                  @click="queryProduct(item.id)"
                >{{item.name}}</a>
              </dd>
            </template>

            <a href="javascript:void(0);" class="sy_gd">更多</a>
          </dl>
          <dl class="cateItem clearfix">
            <dt>产品：</dt>
            <template v-if="mList.length">
              <dd>
                <a href="javascript:void(0);" @click="All">全部产品</a>
              </dd>
              <dd v-for="item in mList" :key="item.product_id">
                <a
                  href="javascript:void(0);"
                  @click="godetail(item.product_id)"
                >{{item.product_name}}</a>
              </dd>
              <a href="javascript:void(0);" class="sy_gd">更多</a>
            </template>
            <h2 v-else>暂无数据</h2>
          </dl>
        </div>
        <div class="productBOx" v-loading="loading">
          <template v-show="JSON.stringify(productList)!=='[]'">
            <div class="listItem" v-for="item in productList" :key="item[0].product_id">
              <h2 class="productTitle">
                <span>{{item[0].name}}</span>
              </h2>
              <div class="productList">
                <ul class="more_list clearfix">
                  <li v-for="item1 in item" :key="item1.product_id">
                    <a href="javascript:void(0);" @click="godetail(item1.product_id)">
                      <div class="more_img">
                        <img :src="item1.product_img" />
                      </div>
                      <div class="more_info">
                        <p class="more_name">{{item1.product_name}}</p>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </template>
          <div class="msg" v-show="JSON.stringify(productList)==='[]'">暂无数据</div>
        </div>
      </div>
    </div>
    <Fotter></Fotter>
  </div>
</template>

<script>
import Nav from '../components/index/nav'
import Fotter from '../components/index/fotter'
import Header from '../components/common/Header'

export default {
  components: {
    Nav,
    Header,
    Fotter
  },
  data() {
    return {
      menuList: [],
      mList: [],
      productList: [],
      keywords: '',
      loading: true,
      flag: false,
      logoUlr: ''
    }
  },
  created() {
    document.onkeydown = e => {
      if (e.keyCode == 13) {
        this.queryProductList()
      }
    }
    this.querymenuList()
    this.queryProductList()
  },
  methods: {
    //   产品分类
    async querymenuList() {
      this.menuList = []
      const { data: res } = await this.$http.get('api/index/getcate')
      if (res.code == 1) {
        this.menuList = res.data
        this.queryProduct(this.menuList[0].id)
      }
    },
    // 产品
    async queryProduct(id) {
      let params = new URLSearchParams()
      params.append('cate_id', id)
      const { data: res } = await this.$http.post(
        'api/index/getproduct',
        params
      )
      this.mList = res.data
      if (this.flag) {
        this.queryProductList(id)
      }
      if (!this.flag) {
        this.flag = true
      }
    },
    searchProductList() {
      this.queryProductList()
    },
    // 产品列表
    async queryProductList(cate_id = '') {
      this.loading = true
      let params = new URLSearchParams()
      params.append('cate_id', cate_id)
      params.append('keywords', this.keywords)
      const { data: res } = await this.$http.post(
        '/api/index/productlst',
        params
      )

      if (res.code) {
        this.productList = res.data
      }
      this.loading = false
    },
    godetail(id) {
      this.$router.push(`/detail?id=${id}`)
    },
    All() {
      this.keywords = ''
      this.cate_id = ''
      this.searchProductList()
    }
  },
  mounted() {
    this.$nextTick(_ => {
      if (window.sessionStorage.getItem('keywords')) {
        this.keywords = window.sessionStorage.getItem('keywords')
        this.queryProductList()
        window.sessionStorage.removeItem('keywords')
      }
      $('.cateItem').on('click', 'dd a', function() {
        if (!$(this).hasClass('current')) {
          $(this)
            .addClass('current')
            .parent('dd')
            .siblings('dd')
            .children('a')
            .removeClass('current')
        }
      })

      if (window.location.hash.includes('index')) {
        window.addEventListener('scroll', function(e) {
          if (window.pageYOffset >= 730) {
            $('#search')
              .stop()
              .slideDown(500)
          } else {
            $('#search')
              .stop()
              .slideUp()
          }
        })
      }
    })
  }
}
</script>

<style lang="less" scoped>
#productBox {
  background-color: #f5f8fa;
}
.productCate {
  margin-top: 20px;
  .w {
    position: relative;
    .search_box {
      position: absolute;
      left: 323px;
      top: -100px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border: 2px solid #a77c5a;
      width: 480px;
      height: 44px;
      padding: 10px 20px;
      margin-right: 10px;
      input {
        height: 100%;
        width: 85%;
        font-size: 14px;
      }
      .search-button {
        position: absolute;
        top: 0;
        right: 0;
        width: 15%;
        height: 40px;
        background: url('../assets/index/nav_icon/search.png') no-repeat center
          #a77c5a;
      }
    }
    .current {
      color: #a77c5a !important;
    }
    .cateCard {
      border-radius: 4px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      overflow: hidden;
      color: #303133;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 8px 20px 8px 10px;
      font-size: 16px;
      .cateItem {
        margin-bottom: 15px;
        dt,
        dd {
          color: #666;
          float: left;
        }
        dd {
          margin-left: 18px;
        }
        .sy_gd {
          float: right;
        }
      }
    }
    .productBOx {
      margin-top: 30px;
      min-height: 400px;
      .msg {
        font-size: 24px;
        text-align: center;
        line-height: 60px;
      }
      .productTitle {
        font-size: 20px;
        font-weight: bold;
        color: #222;
        margin-top: 15px;
        span {
          padding-left: 7px;
          border-left: 5px solid #a77c5a;
        }
      }
      .productList {
        margin-top: 30px;
        .more_list {
          li {
            float: left;
            width: 290px;
            height: 302px;
            margin: 0px 5px 10px;
            background-color: #fff;
            transition: all 0.3s;
            a {
              display: block;
              width: 100%;
              height: 100%;
              color: #666;
              .more_img {
                padding: 30px 40px 40px;
                img {
                  width: 210px;
                  height: 210px;
                }
              }
              .more_info {
                padding: 0 20px;
                .more_name {
                  height: 48px;
                  line-height: 24px;
                  font-size: 14px;
                  color: #666;
                }
              }
            }
          }
          li:hover {
            box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.1);
            transform: translateY(-10px);
          }
        }
      }
    }
  }
}
</style>